<template>
  <div class="conditions">
    <menuBox :step="5"></menuBox>
    <div class="WordSection1" style="layout-grid: 15.6pt">
      <p class="MsoNormal">
        <b
          ><u
            ><span
              lang="TH"
              style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
              >ข้อกำหนดและเงื่อนไขการใช้บริการแอปพลิเคชัน &quot;เงินบิน&quot;
            </span></u
          ></b
        >
      </p>

      <p class="MsoNormal">
        <b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >&nbsp;</span
          ></b
        >
      </p>

      <p class="MsoNormal">
        <b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >(ฉบับวันที่
          </span></b
        ><b
          ><span style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >27<span lang="TH"> สิงหาคม </span>2568<span lang="TH"
              >)</span
            ></span
          ></b
        >
      </p>

      <p class="MsoNormal">
        <b
          ><span
            lang="TH"
            style="
              font-size: 12pt;
              font-family: 'Cordia New', sans-serif;
              background: #f26621;
            "
            >บริษัท วิมุต แฟมิลี่ จำกัด</span
          ></b
        >
      </p>

      <p class="MsoNormal">
        <b
          ><span
            lang="TH"
            style="
              font-size: 12pt;
              font-family: 'Cordia New', sans-serif;
              background: #f26621;
            "
            >&nbsp;</span
          ></b
        >
      </p>

      <p class="MsoNormal">
        <span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >ข้อกำหนดและเงื่อนไขการให้บริการฉบับนี้ (</span
        ><span style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >“</span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >ข้อกำหนด</span
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >”</span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >) เป็นข้อตกลงที่กำกับดูแลการใช้งานแอปพลิเคชัน </span
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >“</span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >เงินบิน</span
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >”</span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
        >
          (</span
        ><span
          lang="ZH-CN"
          style="
            font-size: 12pt;
            font-family: 'Cordia New', sans-serif;
            background: #f26621;
          "
          >“</span
        ><span
          lang="TH"
          style="
            font-size: 12pt;
            font-family: 'Cordia New', sans-serif;
            background: #f26621;
          "
          >เงินง่ายง่าย เพ</span
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >”</span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >) ซึ่งพัฒนาและบริหารจัดการโดย
          <span style="background: #f26621">บริษัท วิมุต แฟมิลี่ </span
          >จำกัดและให้มีผลใช้บังคับระหว่างบริษัทกับผู้ขอใช้บริการ
        </span>
      </p>

      <p class="MsoNormal">
        <span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >&nbsp;</span
        >
      </p>

      <p class="MsoNormal">
        <span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >ข้อกำหนดนี้ครอบคลุมการใช้งานบริการสินเชื่อพิโคไฟแนนซ์</span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
        >
        </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >การจัดการบัญชีผู้ใช้</span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
        >
        </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >การปฏิสัมพันธ์กับบริษัท รวมถึงการประมวลผลข้อมูลส่วนบุคคล</span
        >
      </p>

      <p class="MsoNormal">
        <span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >&nbsp;</span
        >
      </p>

      <p class="MsoNormal">
        <span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >ผู้ขอใช้บริการมีหน้าที่ต้องทำความเข้าใจข้อกำหนดฉบับนี้โดยละเอียดก่อนการลงทะเบียนหรือเริ่มต้นใช้บริการ
          การที่ผู้ขอใช้บริการดำเนินการลงทะเบียนและกดยอมรับข้อกำหนด
          ถือว่าผู้ขอใช้บริการได้อ่าน ทำความเข้าใจ
          และตกลงยินยอมที่จะผูกพันตามข้อกำหนดทุกประการ
          หากผู้ขอใช้บริการไม่ตกลงตามข้อกำหนดนี้
          กรุณายุติการลงทะเบียนและงดเว้นการใช้บริการใด ๆ ทั้งสิ้น
        </span>
      </p>

      <p class="MsoNormal">
        <span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >&nbsp;</span
        >
      </p>

      <p class="MsoNormal">
        <b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >ข้อ
          </span></b
        ><b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >1.
          </span></b
        ><b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >คำนิยาม</span
          ></b
        >
      </p>

      <p class="MsoListParagraphCxSpFirst" style="text-indent: -0.25in">
        <span lang="ZH-CN" style="font-size: 8pt; font-family: Symbol"
          >·<span style="font: 7pt 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ><b
          ><span style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >“</span
          ></b
        ><b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >บริษัท วิมุต แฟมิลี่ จำกัด</span
          ></b
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
        >
          โฮลดิ้ง จำกัด และให้หมายความรวมถึงบุคคลที่บริษัทมอบหมายด้วย</span
        >
      </p>

      <p class="MsoListParagraphCxSpMiddle" style="text-indent: -0.25in">
        <span lang="ZH-CN" style="font-size: 8pt; font-family: Symbol"
          >·<span style="font: 7pt 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ><b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >“</span
          ></b
        ><b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >ผู้ขอใช้บริการ</span
          ></b
        ><b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >”</span
          ></b
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
        >
          หมายถึง บุคคลที่ดาวน์โหลด ลงทะเบียน และ/หรือใช้บริการใด ๆ
          ผ่านแอปพลิเคชันของบริษัท</span
        >
      </p>

      <p class="MsoListParagraphCxSpMiddle" style="text-indent: -0.25in">
        <span lang="ZH-CN" style="font-size: 8pt; font-family: Symbol"
          >·<span style="font: 7pt 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ><b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >“</span
          ></b
        ><b
          ><span
            lang="TH"
            style="
              font-size: 12pt;
              font-family: 'Cordia New', sans-serif;
              background: #f26621;
            "
            >เงินง่ายง่าย เพ</span
          ></b
        ><b
          ><span
            lang="ZH-CN"
            style="
              font-size: 12pt;
              font-family: 'Cordia New', sans-serif;
              background: #f26621;
            "
            >”</span
          ></b
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
        >
          หมายถึง แอปพลิเคชัน </span
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >“</span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >เงินบิน</span
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >” </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >ที่บริษัทเป็นผู้ให้บริการ
        </span>
      </p>

      <p class="MsoListParagraphCxSpMiddle" style="text-indent: -0.25in">
        <span lang="ZH-CN" style="font-size: 8pt; font-family: Symbol"
          >·<span style="font: 7pt 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ><b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >“</span
          ></b
        ><b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >สินเชื่อพิโคไฟแนนซ์</span
          ></b
        ><b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >”
          </span></b
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >หมายถึง
          สินเชื่อรายย่อยระดับจังหวัดภายใต้การกำกับของกระทรวงการคลังที่บริษัทได้รับอนุญาตให้ประกอบธุรกิจ</span
        >
      </p>

      <p class="MsoListParagraphCxSpMiddle" style="text-indent: -0.25in">
        <span lang="ZH-CN" style="font-size: 8pt; font-family: Symbol"
          >·<span style="font: 7pt 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ><b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >“</span
          ></b
        ><b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >เครื่องมือเพื่อการทำรายการ</span
          ></b
        ><b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >”</span
          ></b
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
        >
          หมายถึง โทรศัพท์มือถือ แท็บเล็ต
          หรืออุปกรณ์อิเล็กทรอนิกส์อื่นใดที่สามารถใช้บริการแอปพลิเคชันได้</span
        >
      </p>

      <p class="MsoListParagraphCxSpMiddle" style="text-indent: -0.25in">
        <span lang="ZH-CN" style="font-size: 8pt; font-family: Symbol"
          >·<span style="font: 7pt 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ><b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >“</span
          ></b
        ><b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >รหัสประจำตั</span
          ></b
        ><b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >ว</span
          ></b
        ><b
          ><span style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >”</span
          ></b
        ><b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >
          </span></b
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >หมายถึง รหัส </span
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >PIN, </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >ข้อมูลชีวภาพ (</span
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >Biometric) </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >เช่น ลายนิ้วมือหรือใบหน้า</span
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >, </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >รหัส </span
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >OTP (One Time Password) </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >รวมถึงรหัสอื่นใดที่ใช้ในการยืนยันตัวตนเพื่อเข้าใช้แอปพลิเคชัน</span
        >
      </p>

      <p class="MsoListParagraphCxSpMiddle" style="text-indent: -0.25in">
        <span lang="ZH-CN" style="font-size: 8pt; font-family: Symbol"
          >·<span style="font: 7pt 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ><b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >“</span
          ></b
        ><b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >บัญชีรับเงิน</span
          ></b
        ><b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >”</span
          ></b
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
        >
          หมายถึง
          บัญชีเงินฝากธนาคารในประเทศไทยที่ผู้ขอใช้บริการเป็นเจ้าของแต่เพียงผู้เดียว
          และได้ลงทะเบียนไว้กับบริษัทเพื่อรับเงินสินเชื่อ</span
        >
      </p>

      <p class="MsoListParagraphCxSpLast" style="text-indent: -0.25in">
        <span lang="ZH-CN" style="font-size: 8pt; font-family: Symbol"
          >·<span style="font: 7pt 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ><b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >“</span
          ></b
        ><b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >เหตุสุดวิสัย</span
          ></b
        ><b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >”</span
          ></b
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
        >
          หมายถึง เหตุใดๆ อันอยู่นอกเหนือการควบคุมของบริษัท
          ซึ่งเป็นอุปสรรคต่อการให้บริการ เช่น
          ระบบคอมพิวเตอร์หรือการสื่อสารขัดข้อง</span
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >, </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >ไฟฟ้าขัดข้อง</span
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >, </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >การกระทำของบุคคลภายนอก หรือไวรัสคอมพิวเตอร์</span
        >
      </p>

      <p class="MsoNormal">
        <span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >&nbsp;</span
        >
      </p>

      <p class="MsoNormal">
        <b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >ข้อ
          </span></b
        ><b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >2.
          </span></b
        ><b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >คุณสมบัติของผู้ขอใช้บริการ</span
          ></b
        >
      </p>

      <p class="MsoNormal" style="text-indent: 21pt">
        <b
          ><span style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >2.1.</span
          ></b
        ><span style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >   </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >ผู้ขอใช้บริการต้องเป็นบุคคลธรรมดา มีสัญชาติไทย และมีอายุไม่ต่ำกว่า </span
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >20</span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
        >
          ปีบริบูรณ์ และมีความสามารถตามกฎหมายในการทำสัญญา
        </span>
      </p>

      <p class="MsoNormal" style="text-indent: 21pt">
        <b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >2.2.</span
          ></b
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >   </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >ผู้ขอใช้บริการต้องมีภูมิลำเนา หรือที่อยู่ปัจจุบัน
          หรือสถานที่ทำงานหลัก อยู่ในเขตจังหวัดกรุงเทพมหานคร</span
        >
      </p>

      <p class="MsoNormal" style="text-indent: 21pt">
        <b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >2.3.</span
          ></b
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >   </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >ผู้ขอใช้บริการต้องมีคุณสมบัติอื่นๆ
          ครบถ้วนตามหลักเกณฑ์การพิจารณาสินเชื่อของบริษัทและตามที่กฎหมายกำหนด</span
        >
      </p>

      <p class="MsoNormal">
        <span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >&nbsp;</span
        >
      </p>

      <p class="MsoNormal">
        <b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >ข้อ
          </span></b
        ><b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >3.
          </span></b
        ><b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >การใช้และการเก็บรักษารหัสประจำตัว</span
          ></b
        >
      </p>

      <p class="MsoNormal" style="margin-left: 21pt">
        <b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >3.1.</span
          ></b
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >   </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >ผู้ขอใช้บริการต้องเก็บรักษารหัสประจำตัวและรหัสผ่านของตนเองไว้เป็นความลับสูงสุด 
          และจะไม่เปิดเผยให้บุคคลอื่นทราบ</span
        >
      </p>

      <p class="MsoNormal" style="margin-left: 21pt">
        <b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >3.2.</span
          ></b
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >   </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >ผู้ขอใช้บริการต้องเก็บรักษาเครื่องมือเพื่อการทำรายการไว้ในที่ปลอดภัย
          และต้องไม่ดัดแปลงระบบปฏิบัติการ (เช่น </span
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >Jailbreak </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >หรือ </span
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >Root) </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >หรือติดตั้งโปรแกรมที่อาจเป็นอันตราย
          ซึ่งอาจส่งผลต่อความปลอดภัยในการทำธุรกรรม</span
        >
      </p>

      <p class="MsoNormal" style="margin-left: 21pt">
        <b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >3.3.</span
          ></b
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >   </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >หากมีการกระทำใด ๆ ผ่านบัญชีของผู้ขอใช้บริการ
          จะถือว่าเป็นการกระทำของผู้ใช้บริการเอง
        </span>
      </p>

      <p class="MsoNormal" style="margin-left: 21pt">
        <b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >3.4.</span
          ></b
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >   </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >กรณีที่รหัสประจำตัวสูญหายหรือถูกโจรกรรม
          ผู้ขอใช้บริการต้องแจ้งบริษัททันทีผ่านช่องทางที่ระบุไว้ในข้อ </span
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >15</span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
        >
          เพื่อระงับบริการ ทั้งนี้ ธุรกรรมใด ๆ
          ที่เกิดขึ้นก่อนการระงับบริการจะถือว่ามีผลผูกพันผู้ขอใช้บริการทุกประการ</span
        >
      </p>

      <p class="MsoNormal">
        <span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >&nbsp;</span
        >
      </p>

      <p class="MsoNormal">
        <b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >ข้อ
          </span></b
        ><b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >4.
          </span></b
        ><b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >การใช้บริการแอปพลิเคชัน</span
          ></b
        >
      </p>

      <p class="MsoNormal" style="margin-left: 21pt">
        <b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >4.1.</span
          ></b
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >   </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >ผู้ขอใช้บริการตกลงจะให้ข้อมูลที่เป็นจริง ถูกต้อง
          และเป็นปัจจุบันแก่บริษัทเสมอ
        </span>
      </p>

      <p class="MsoNormal" style="margin-left: 21pt">
        <b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >4.2.  
          </span></b
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >ผู้ขอใช้บริการตกลงที่จะไม่ใช้บริการเพื่อกิจกรรมที่ผิดกฎหมาย
          การหลอกลวง หรือเข้าข่ายฉ้อโกง
        </span>
      </p>

      <p class="MsoNormal" style="margin-left: 21pt">
        <b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >4.3.</span
          ></b
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >   </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >การเข้าสู่ระบบด้วยรหัสประจำตัว รวมถึงข้อมูลชีวภาพ (</span
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >Biometric) </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >ถือว่าเป็นการกระทำของผู้ขอใช้บริการเอง และมีผลผูกพันทุกประการ
          หากกรอกรหัสผิดเกินจำนวนครั้งที่กำหนด
          บริษัทจะระงับการใช้งานชั่วคราวเพื่อความปลอดภัย</span
        >
      </p>

      <p class="MsoNormal" style="margin-left: 21pt">
        <b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >4.4.</span
          ></b
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
        >
        </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >ผู้ขอใช้บริการสามารถทำรายการผ่านแอปพลิเคชันได้ดังนี้</span
        >
      </p>

      <p
        class="MsoListParagraphCxSpFirst"
        style="margin-left: 57pt; text-indent: -0.25in"
      >
        <span lang="ZH-CN" style="font-size: 8pt; font-family: Symbol"
          >·<span style="font: 7pt 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ><u
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >การคำนวณวงเงินและยื่นขอสินเชื่อ</span
          ></u
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
        >
        </span>
      </p>

      <p class="MsoListParagraphCxSpMiddle" style="margin-left: 57pt">
        <span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >วงเงินที่แสดงผลเบื้องต้นเป็นเพียงการประเมินจากข้อมูลที่ผู้ใช้บริการให้ไว้เท่านั้น
          การอนุมัติจริงจะขึ้นอยู่กับการพิจารณาข้อมูลและเอกสารประกอบทั้งหมดตามหลักเกณฑ์ของบริษัท</span
        >
      </p>

      <p
        class="MsoListParagraphCxSpMiddle"
        style="margin-left: 57pt; text-indent: -0.25in"
      >
        <span lang="ZH-CN" style="font-size: 8pt; font-family: Symbol"
          >·<span style="font: 7pt 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ><u
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >การเบิกใช้สินเชื่อ</span
          ></u
        >
      </p>

      <p class="MsoListParagraphCxSpMiddle" style="margin-left: 57pt">
        <span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >สามารถทำรายการเบิกใช้สินเชื่อตามวงเงินที่ได้รับอนุมัติเข้าบัญชีรับเงิน</span
        >
      </p>

      <p
        class="MsoListParagraphCxSpMiddle"
        style="margin-left: 57pt; text-indent: -0.25in"
      >
        <span lang="ZH-CN" style="font-size: 8pt; font-family: Symbol"
          >·<span style="font: 7pt 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ><u
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >การรับเอกสารอิเล็กทรอนิกส์</span
          ></u
        >
      </p>

      <p class="MsoListParagraphCxSpLast" style="margin-left: 57pt">
        <span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >ผู้ขอใช้บริการตกลงรับใบแจ้งหนี้</span
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >, </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >ใบเสร็จรับเงิน และเอกสารสำคัญอื่น ๆ ผ่านช่องทางแอปพลิเคชัน
          และถือว่าได้รับเอกสารดังกล่าวโดยชอบแล้ว</span
        >
      </p>

      <p class="MsoNormal">
        <span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >&nbsp;</span
        >
      </p>

      <p class="MsoNormal">
        <b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >ข้อ
          </span></b
        ><b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >5.
          </span></b
        ><b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >อัตราดอกเบี้ย ค่าปรับ และค่าบริการ</span
          ></b
        >
      </p>

      <p class="MsoNormal" style="margin-left: 21pt">
        <b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >5.1.</span
          ></b
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >   </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >ผู้ขอใช้บริการตกลงชำระดอกเบี้ย ค่าปรับ ค่าบริการ
          และค่าธรรมเนียมอื่นใดที่เกี่ยวข้องกับสินเชื่อพิโคไฟแนนซ์ (หากมี)
          ตามอัตราที่บริษัทประกาศกำหนด</span
        >
      </p>

      <p class="MsoNormal" style="margin-left: 21pt">
        <b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >5.2.</span
          ></b
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >   </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >อัตราดอกเบี้ย ค่าปรับ ค่าบริการ และค่าธรรมเนียมใดๆ เมื่อรวมกันแล้ว
          จะต้องไม่เกินอัตราสูงสุดที่กระทรวงการคลังประกาศกำหนด
          สำหรับสินเชื่อพิโคไฟแนนซ์ ซึ่งคำนวณแบบลดต้นลดดอก (</span
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >Effective Rate)</span
        >
      </p>

      <p class="MsoNormal" style="margin-left: 21pt">
        <b
          ><span style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >5.3.</span
          ></b
        ><span style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >  
          <span lang="TH"
            >หากผู้ขอใช้บริการไม่ชำระหนี้ภายในเวลาที่กำหนด
            จะถือเป็นการผิดนัดชำระ
            และบริษัทมีสิทธิคิดดอกเบี้ยผิดนัดชำระและค่าธรรมเนียมอื่นใดตามที่ระบุไว้ในสัญญากู้ยืมเงินและเป็นไปตามที่กฎหมายกำหนด</span
          ></span
        >
      </p>

      <p class="MsoNormal" style="margin-left: 21pt">
        <span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >&nbsp;</span
        >
      </p>

      <p class="MsoNormal">
        <b
          ><span
            lang="AR-SA"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >ข้อ
          </span></b
        ><b
          ><span style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >6.
          </span></b
        ><b
          ><span
            lang="AR-SA"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >การชำระคืนสินเชื่อ
          </span></b
        ><span
          lang="AR-SA"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          > </span
        >
      </p>

      <p class="MsoNormal" style="margin-left: 21pt">
        <b
          ><span style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >6.1.</span
          ></b
        ><span style="font-size: 12pt; font-family: 'Cordia New', sans-serif">
        </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >ผู้ขอใช้บริการมีหน้าที่และความรับผิดชอบในการชำระคืนเงินต้น
          พร้อมด้วยดอกเบี้ยและค่าธรรมเนียมอื่นใด (ถ้ามี)
          ให้ครบถ้วนตรงตามจำนวนและกำหนดเวลาที่ระบุไว้ในสัญญากู้ยืมเงิน
        </span>
      </p>

      <p class="MsoNormal" style="margin-left: 21pt">
        <span style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >6.2.   </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >การชำระหนี้จะต้องดำเนินการผ่านช่องทางที่บริษัทกำหนดไว้ในแอปพลิเคชันหรือช่องทางอื่นที่บริษัทประกาศแจ้งให้ทราบอย่างเป็นทางการเท่านั้น
          ผู้ขอใช้บริการมีหน้าที่ต้องเก็บรักษาหลักฐานการชำระเงินไว้เพื่อประโยชน์ในการตรวจสอบสถานะการชำระหนี้
        </span>
      </p>

      <p class="MsoNormal" style="margin-left: 21pt">
        <span style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >6.3.   </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >ผู้ขอใช้บริการมีสิทธิในการชำระคืนหนี้สินเชื่อทั้งหมดหรือบางส่วนก่อนครบกำหนดชำระได้
          (</span
        ><span style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >Prepayment) </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >ตามขั้นตอนและวิธีการที่บริษัทกำหนด ทั้งนี้
          การคำนวณส่วนลดดอกเบี้ยในกรณีชำระคืนก่อนกำหนดจะเป็นไปตามหลักเกณฑ์ที่กฎหมายว่าด้วยสินเชื่อพิโคไฟแนนซ์กำหนด
        </span>
      </p>

      <p class="MsoNormal" style="margin-left: 21pt">
        <span style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >6.4. </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >ในกรณีที่ผู้ขอใช้บริการมีความประสงค์จะขอเลื่อนกำหนดการชำระหนี้
          จะต้องแจ้งความจำนงต่อบริษัทผ่านช่องทางที่กำหนดล่วงหน้าตามสมควร ทั้งนี้
          การอนุมัติคำขอดังกล่าวขึ้นอยู่กับดุลยพินิจของบริษัทแต่เพียงผู้เดียว
          และบริษัทอาจกำหนดเงื่อนไขเพิ่มเติมเพื่อประกอบการพิจารณา
        </span>
      </p>

      <p class="MsoNormal" style="margin-left: 21pt">
        <span style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >&nbsp;</span
        >
      </p>

      <p class="MsoNormal">
        <b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >ข้อ
          </span></b
        ><b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >7.
          </span></b
        ><b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >ความสมบูรณ์ของธุรกรรมและผลผูกพัน</span
          ></b
        >
      </p>

      <p class="MsoNormal" style="margin-left: 21pt">
        <b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >7.1.</span
          ></b
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
        >
        </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >การทำธุรกรรมใด ๆ ผ่านแอปพลิเคชันโดยใช้รหัสประจำตัวของผู้ขอใช้บริการ
          ให้ถือว่าเป็นการกระทำที่สมบูรณ์และผูกพันผู้ขอใช้บริการเสมือนหนึ่งได้ลงลายมือชื่อในเอกสารด้วยตนเอง
          และให้ถือว่าเป็นการลงลายมือชื่ออิเล็กทรอนิกส์ตามกฎหมาย</span
        >
      </p>

      <p class="MsoNormal" style="margin-left: 21pt">
        <b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >7.2.</span
          ></b
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >   </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >ผู้ขอใช้บริการรับรองว่าข้อมูล ภาพถ่าย
          และเอกสารทั้งหมดที่นำส่งผ่านแอปพลิเคชันเป็นข้อมูลที่ถูกต้อง เป็นจริง
          และเป็นปัจจุบัน หากบริษัทตรวจพบว่าข้อมูลเป็นเท็จหรือไม่ถูกต้อง
          บริษัทมีสิทธิระงับหรือยกเลิกการให้บริการได้ทันที
          และผู้ขอใช้บริการจะต้องรับผิดชอบต่อความเสียหายที่เกิดขึ้น</span
        >
      </p>

      <p class="MsoNormal" style="margin-left: 21pt">
        <b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >7.3.</span
          ></b
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >   </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >เมื่อผู้ขอใช้บริการได้ยืนยันการทำรายการสินเชื่อเสร็จสิ้นแล้ว
          จะไม่สามารถยกเลิกหรือเปลี่ยนแปลงได้
          และถือว่าผู้ขอใช้บริการได้ตกลงเข้าทำสัญญาสินเชื่อกับบริษัทและมีผลผูกพันตามกฎหมายแล้ว</span
        >
      </p>

      <p class="MsoNormal">
        <span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >&nbsp;</span
        >
      </p>

      <p class="MsoNormal">
        <b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >ข้อ
          </span></b
        ><b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >8.
          </span></b
        ><b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >การป้องกันและปราบปรามการฟอกเงิน (</span
          ></b
        ><b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >AML)</span
          ></b
        >
      </p>

      <p class="MsoNormal" style="margin-left: 21pt">
        <b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >8.1.</span
          ></b
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >   </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >ผู้ขอใช้บริการรับทราบว่าบริษัทมีหน้าที่ตามกฎหมายว่าด้วยการป้องกันและปราบปรามการฟอกเงิน
          ดังนั้น ผู้ขอใช้บริการตกลงยินยอมให้บริษัทดำเนินการดังนี้</span
        >
      </p>

      <p
        class="MsoListParagraphCxSpFirst"
        style="margin-left: 57pt; text-indent: -0.25in"
      >
        <span lang="ZH-CN" style="font-size: 8pt; font-family: Symbol"
          >·<span style="font: 7pt 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ><u
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >การตรวจสอบเพื่อทราบข้อเท็จจริงเกี่ยวกับลูกค้า (</span
          ></u
        ><u
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >Customer Due Diligence)</span
          ></u
        >
      </p>

      <p class="MsoListParagraphCxSpMiddle" style="margin-left: 57pt">
        <span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >บริษัทจะจัดให้มีการแสดงตนและตรวจสอบข้อมูลของผู้ขอใช้บริการตามที่กฎหมายกำหนด</span
        >
      </p>

      <p
        class="MsoListParagraphCxSpMiddle"
        style="margin-left: 57pt; text-indent: -0.25in"
      >
        <span lang="ZH-CN" style="font-size: 8pt; font-family: Symbol"
          >·<span style="font: 7pt 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ><u
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >การรายงานธุรกรรม</span
          ></u
        >
      </p>

      <p class="MsoListParagraphCxSpLast" style="margin-left: 57pt">
        <span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >บริษัทอาจมีความจำเป็นต้องรายงานข้อมูลธุรกรรมของผู้ขอใช้บริการต่อสำนักงานป้องกันและปราบปรามการฟอกเงิน
          (ปปง.) ตามหลักเกณฑ์ของกฎหมาย</span
        >
      </p>

      <p class="MsoNormal" style="margin-left: 21pt">
        <b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >8.2.</span
          ></b
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >   </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >ผู้ขอใช้บริการสามารถศึกษารายละเอียดเพิ่มเติมเกี่ยวกับแนวปฏิบัติของบริษัทได้ที่ </span
        ><b
          ><i
            ><span
              style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
              >“</span
            ></i
          ></b
        ><b
          ><i
            ><span
              lang="TH"
              style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
              >ประกาศนโยบายการป้องกันและปราบปรามการฟอกเงินและการต่อต้านการสนับสนุนทางการเงินแก่การก่อการร้าย
              (</span
            ></i
          ></b
        ><b
          ><i
            ><span
              lang="ZH-CN"
              style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
              >AML/CFT)</span
            ></i
          ></b
        ><b
          ><i
            ><span
              lang="ZH-CN"
              style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
              >”</span
            ></i
          ></b
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
        >
        </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >บนแอปพลิเคชัน หรือเว็บไซต์ของบริษัท</span
        >
      </p>

      <p class="MsoNormal">
        <b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >ข้อ
          </span></b
        ><b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >9.
          </span></b
        ><b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >การติดตามทวงถามหนี้</span
          ></b
        >
      </p>

      <p class="MsoNormal" style="margin-left: 21pt">
        <span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >ในกรณีที่ผู้ขอใช้บริการผิดนัดชำระหนี้
          บริษัทหรือผู้ที่ได้รับมอบหมายจะดำเนินการติดตามทวงถามหนี้ภายใต้กรอบของ
          พระราชบัญญัติการทวงถามหนี้ พ.ศ. </span
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >2558</span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
        >
          และกฎหมายอื่นที่เกี่ยวข้องอย่างเคร่งครัด</span
        >
      </p>

      <p class="MsoNormal">
        <span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >&nbsp;</span
        >
      </p>

      <p class="MsoNormal">
        <b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >ข้อ
          </span></b
        ><b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >10.
          </span></b
        ><b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >การเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคล</span
          ></b
        >
      </p>

      <p class="MsoNormal" style="margin-left: 21pt">
        <span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >บริษัทจะเก็บรวบรวม ใช้
          และเปิดเผยข้อมูลส่วนบุคคลของผู้ใช้บริการตามที่ระบุไว้ใน </span
        ><b
          ><i
            ><span
              style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
              >“</span
            ></i
          ></b
        ><b
          ><i
            ><span
              lang="TH"
              style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
              >ประกาศนโยบายความเป็นส่วนตัว</span
            ></i
          ></b
        ><b
          ><i
            ><span
              lang="ZH-CN"
              style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
              >”
            </span></i
          ></b
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >ที่ประกาศบนแอปพลิเคชัน ซึ่งข้อมูลดังกล่าวรวมถึงแต่ไม่จำกัดเพียง
          ข้อมูลทางการเงิน ข้อมูลติดต่อ รายการแอปพลิเคชัน ข้อความ </span
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >SMS </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >ภาพถ่าย ข้อมูลอุปกรณ์ และตำแหน่งที่ตั้ง
          โดยมีวัตถุประสงค์หลักเพื่อการยืนยันตัวตน การวิเคราะห์สินเชื่อ
          และการป้องกันการฉ้อโกง
        </span>
      </p>

      <p class="MsoNormal">
        <span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >&nbsp;</span
        >
      </p>

      <p class="MsoNormal">
        <b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >ข้อ
          </span></b
        ><b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >11.
          </span></b
        ><b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >ทรัพย์สินทางปัญญา</span
          ></b
        >
      </p>

      <p class="MsoNormal" style="margin-left: 21pt">
        <span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >เครื่องหมายการค้า ชื่อ โลโก้ รหัสซอฟต์แวร์ ส่วนต่อประสานผู้ใช้
          และสิทธิ์ในทรัพย์สินทางปัญญาทั้งหมดในแอปพลิเคชัน </span
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >“<span style="background: #f26621"
            >&quot;เงินง่ายง่ายเพ&quot; เป็นทรัพย์สินของบริษัทนี้</span
          ></span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
        >
          ห้ามมิให้ทำซ้ำ ดัดแปลง เผยแพร่
          หรือใช้ประโยชน์โดยไม่ได้รับอนุญาตเป็นลายลักษณ์อักษรจากบริษัท
        </span>
      </p>

      <p class="MsoNormal">
        <span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >&nbsp;</span
        >
      </p>

      <p class="MsoNormal">
        <b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >ข้อ
          </span></b
        ><b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >12.
          </span></b
        ><b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >บริการของบุคคลที่สามและข้อจำกัดความรับผิด</span
          ></b
        >
      </p>

      <p class="MsoNormal" style="margin-left: 21pt">
        <b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >12.1.</span
          ></b
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
        >
        </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >แอปพลิเคชันอาจมีการเชื่อมต่อหรือใช้งานบริการจากบุคคลที่สาม เช่น </span
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >Firebase, Appsflyer </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >เพื่อการวิเคราะห์และปรับปรุงบริการ
          บริษัทไม่รับผิดชอบต่อเนื้อหาหรือบริการจากบุคคลที่สามดังกล่าว
        </span>
      </p>

      <p class="MsoNormal" style="margin-left: 21pt">
        <b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >12.2.</span
          ></b
        ><span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
        >
        </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >บริษัทไม่รับประกันความถูกต้องหรือผลลัพธ์จากการใช้งานบริการ
          และไม่รับผิดชอบต่อความเสียหายทางอ้อมหรือผลสืบเนื่องใด ๆ
          ที่เกิดจากการใช้บริการ การใช้บริการถือเป็นความเสี่ยงของผู้ใช้บริการเอง
        </span>
      </p>

      <p class="MsoNormal">
        <span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >&nbsp;</span
        >
      </p>

      <p class="MsoNormal">
        <b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >ข้อ
          </span></b
        ><b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >13.
          </span></b
        ><b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >การระงับและยุติการใช้บริการ</span
          ></b
        >
      </p>

      <p class="MsoNormal" style="margin-left: 21pt">
        <b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >1</span
          ></b
        ><b
          ><span style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >3.1.</span
          ></b
        ><span style="font-size: 12pt; font-family: 'Cordia New', sans-serif">
          <span lang="TH"
            >บริษัทมีสิทธิระงับหรือยกเลิกการให้บริการชั่วคราวหรือถาวรได้
            โดยจะแจ้งให้ทราบล่วงหน้าไม่น้อยกว่า
          </span></span
        ><span style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >30 </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >วัน เว้นแต่ในกรณีที่ผู้ขอใช้บริการปฏิบัติผิดเงื่อนไข</span
        ><span style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >, </span
        ><span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >กระทำการทุจริต หรือมีเหตุจำเป็นอื่นที่ไม่อาจแจ้งล่วงหน้าได้
          บริษัทสามารถระงับบริการได้ทันที</span
        >
      </p>

      <p class="MsoNormal" style="margin-left: 21pt">
        <b
          ><span style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >13.2.</span
          ></b
        ><span style="font-size: 12pt; font-family: 'Cordia New', sans-serif">
          <span lang="TH"
            >ผู้ขอใช้บริการสามารถขอยกเลิกการใช้แอปพลิเคชันได้โดยแจ้งให้บริษัททราบล่วงหน้า
            แต่จะยกเลิกได้ก็ต่อเมื่อได้ชำระหนี้สินเชื่อที่มีกับบริษัทครบถ้วนแล้วเท่านั้น</span
          ></span
        >
      </p>

      <p class="MsoNormal">
        <span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >&nbsp;</span
        >
      </p>

      <p class="MsoNormal">
        <b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >ข้อ
          </span></b
        ><b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >14.
          </span></b
        ><b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >การแก้ไขข้อกำหนด</span
          ></b
        >
      </p>

      <p class="MsoNormal" style="margin-left: 21pt">
        <span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >บริษัทสงวนสิทธิ์ในการแก้ไขหรือเปลี่ยนแปลงข้อกำหนดและเงื่อนไขการใช้บริการนี้ตามความเหมาะสม
          โดยบริษัทจะแจ้งให้ผู้ขอใช้บริการทราบล่วงหน้าไม่น้อยกว่า 30 วัน
          ผ่านช่องทางแอปพลิเคชัน เว็บไซต์ หรือช่องทางอื่นที่บริษัทเห็นสมควร
          การที่ผู้ขอใช้บริการยังคงใช้บริการต่อไปหลังการเปลี่ยนแปลง
          ถือว่าผู้ขอใช้บริการยอมรับข้อกำหนดที่แก้ไขใหม่แล้ว</span
        >
      </p>

      <p class="MsoNormal" style="margin-left: 21pt">
        <span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >&nbsp;</span
        >
      </p>

      <p class="MsoNormal">
        <b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >ข้อ
          </span></b
        ><b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >15.
          </span></b
        ><b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >กฎหมายที่ใช้บังคับและการระงับข้อพิพาท</span
          ></b
        >
      </p>

      <p class="MsoNormal" style="margin-left: 21pt">
        <span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >ข้อกำหนดนี้ให้อยู่ภายใต้การบังคับของกฎหมายแห่งราชอาณาจักรไทย
          หากมีข้อพิพาทใด ๆ เกิดขึ้น
          ให้คู่กรณีตกลงระงับข้อพิพาทนั้นโดยให้ศาลไทยเป็นศาลที่มีเขตอำนาจในการพิจารณาข้อพิพาทที่เกิดขึ้น</span
        >
      </p>

      <p class="MsoNormal">
        <span
          lang="ZH-CN"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >&nbsp;</span
        >
      </p>

      <p class="MsoNormal">
        <b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >ข้อ
          </span></b
        ><b
          ><span
            lang="ZH-CN"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >16.
          </span></b
        ><b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >การติดต่อบริษัท</span
          ></b
        >
      </p>

      <p class="MsoNormal" style="margin-left: 21pt">
        <span
          lang="TH"
          style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
          >หากมีข้อสงสัยหรือต้องการร้องเรียนเกี่ยวกับบริการ
          กรุณาติดต่อตามช่องทางต่อไปนี้</span
        >
      </p>

      <p
        class="MsoListParagraphCxSpFirst"
        style="margin-left: 57pt; text-indent: -0.25in"
      >
        <span lang="ZH-CN" style="font-size: 8pt; font-family: Symbol"
          >·<span style="font: 7pt 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ><b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >อีเมล</span
          ></b
        ><b
          ><span
            lang="ZH-CN"
            style="
              font-size: 12pt;
              font-family: 'Cordia New', sans-serif;
              background: #f26621;
            "
            >:</span
          ></b
        ><span
          lang="ZH-CN"
          style="
            font-size: 12pt;
            font-family: 'Cordia New', sans-serif;
            background: #f26621;
          "
        >
        </span
        ><b
          ><span
            style="
              font-family: 'Microsoft YaHei', sans-serif;
              background: #f26621;
            "
            ><a href="mailto:ads@wimutfamily.com">ads@wimutfamily.com</a></span
          ></b
        >
      </p>

      <p
        class="MsoListParagraphCxSpMiddle"
        style="margin-left: 57pt; text-indent: -0.25in"
      >
        <span style="font-size: 8pt; font-family: Symbol; background: #f26621"
          >·<span style="font: 7pt 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ><b
          ><span
            lang="TH"
            style="font-size: 12pt; font-family: 'Cordia New', sans-serif"
            >ที่อยู่:
          </span></b
        ><b
          ><span
            lang="TH"
            style="
              font-size: 12pt;
              font-family: 'Cordia New', sans-serif;
              background: #f26621;
            "
            >บริษัท: 127/126 ซอยรามอินทรา 40 แยก 8-1 นวลจันทร์ 10240</span
          ></b
        >
      </p>

      <p
        class="MsoListParagraphCxSpMiddle"
        style="margin-left: 57pt; text-indent: -0.25in"
      >
        <span style="font-size: 8pt; font-family: Symbol; background: #f26621"
          >·<span style="font: 7pt 'Times New Roman'"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span
        ><b
          ><span
            lang="TH"
            style="
              font-size: 12pt;
              font-family: 'Cordia New', sans-serif;
              background: #f26621;
            "
            > เวลาทำการ: จันทร์-เสาร์ 10.00-18.30 น.</span
          ></b
        >
      </p>

      <p class="MsoListParagraphCxSpLast" style="margin-left: 0in">
        <span
          lang="AR-SA"
          style="
            font-size: 12pt;
            font-family: 'Cordia New', sans-serif;
            background: #f26621;
          "
          >&nbsp;</span
        >
      </p>
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "home",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {
      type: 1,
    };
  },
  mounted() {},
  methods: {
    step() {
      this.$router.push({ path: "categories" });
    },
  },
};
</script>
<style>
.WordSection1 {
  padding: 4vw 8vw;
}
</style>
